import * as React from 'react'
import { IconWrapper } from '../IconWrapper'
import { IconProps } from '../iconConstants'

export const ViewSmallIcon = ({ title, titleId, ...props }: IconProps) => (
    <IconWrapper {...props}>
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="1em"
            height="1em"
            fill="none"
            viewBox="0 0 24 24"
            aria-labelledby={titleId}
            {...props}
        >
            {title ? <title id={titleId}>{title}</title> : null}
            <path stroke="currentColor" d="M20 13s-3.273 5-8 5-8-5-8-5 3.273-5 8-5 8 5 8 5Z" />
            <path stroke="currentColor" d="M9 13a3 3 0 1 0 6 0 3 3 0 0 0-6 0Z" />
        </svg>
    </IconWrapper>
)
